import React from 'react';
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { useTranslation } from 'react-i18next';

import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination, Navigation } from 'swiper/modules';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import DoneIcon from '@mui/icons-material/Done';

import Header from "./common/Header";
import ContactPersons from "../widgets/ContactPersons";
import DisplayVideo from "../dialogs/DisplayVideo";
import Newsletter from '../snippets/Newsletter';
import Advice from '../snippets/Advice';

import ReimoAtTheNews from "../snippets/ReimoAtTheNews";
import Ausbauten from "../snippets/Ausbauten";
import AboutReimo from "../snippets/AboutReimo";
import ReimoSwiper from "../components/ReimoSwiper";

import CarCard from "../widgets/CarCard";

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'animate.css';

import modelsComplete from '../db/models.json';

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  	...theme.typography.body2,
  	padding: theme.spacing(1),
  	textAlign: 'center',
  	color: theme.palette.text.secondary,
}));


function StartContent(props) {
 	const [displayNewsletter, setDisplayNewsletter] = React.useState(false);
 	const [modelAll, SetModels] = React.useState(modelsComplete);

	const models = React.useMemo(() => {
		let f = {};
		f.producer = props.props.filterModelNew.producer;
		f.expansion = props.props.filterModelNew.expansion;
		const filtered = modelAll.cars.filter(item =>
		  Object.entries(f).every(([key, value]) => value === "all" || item[key] === value)
		);
		let newModels = {};
		newModels.cars = filtered;	
		return newModels;		
	}) 
	

	function filterCar(whichCar) {

		let expansion = props.props.filterModelNew.expansion;
	
		let filter = {
			"triostyle": [
				"ford",
				"mb"
			],
			"multistyle": [
				"ford",
				"vw"

			],
			"weekender": [
				"mb"
			],
			"weekender2": [
				"ford",
				"vw"
			],
			"camp2": [
				"ford",
				"vw"
			]
		};
	
		if (expansion === "all") {
			return true;
		}
		else 
			return filter[expansion]?.includes(whichCar) || false;
	}


	function filterModell(whichModell) {
		let whichCar = props.props.filterModelNew.producer;
	
		let filter = {
			"ford": [
				"triostyle",
				"multistyle",
				"weekender",
				"weekender2",
				"camp2"
			],
			"vw": [
				"weekender2",
				"camp2"
			],
			"mb": [
				"triostyle",
				"weekender"
			]
		};
	
		if (whichCar === "all") {
			return true;
		}
		else 
			return filter[whichCar]?.includes(whichModell) || false;
	}
	
  	let navigate = useNavigate(); 

	const { t, i18n } = useTranslation("",{lng: props.language});

const handleFilterModel = (producer) => {
    props.props.handleFilterModell({
        ...props.props.filterModelNew,
        producer,
    });
};

const handleFilterExpansion = (expansion) => {
    props.props.handleFilterModell({
        ...props.props.filterModelNew,
        expansion,
    });
};
	
	const handleDisplayVideo = (newDisplayVideo) => {
		props.props.setDisplayAdvice(false);
	};
	
	const callUrl = (url) => {
		navigate(url);
	};
	
	const [ref0, inView0] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const [ref1, inView1] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const [ref2, inView2] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});	
	
	const [ref3, inView3] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});


const selectedProducer = props.props.filterModelNew.producer;
const selectedExpansion = props.props.filterModelNew.expansion;

const visibleCars = modelsComplete.cars.filter((model) => {
    if (
        model.onlinestatus !== "online" ||
        model.compareable !== "true"
    ) {
        return false;
    }

    const producerMatches =
        selectedProducer === "all" ||
        model.producer === selectedProducer;

    const expansionMatches =
        selectedExpansion === "all" ||
        model.expansion === selectedExpansion;

    return producerMatches && expansionMatches;
});


  	return (<>
	  			<Box>
					<Header setLanguage={props.props.setLanguage} embedded={props.props.embedded}/>

	  			</Box>
				<Box sx={{ flexGrow: 1, display: {
							xs: 'block',
							sm: 'block',  
							md: 'block',  
							lg: 'block',  
							xl: 'block',  							
							} }}
				>			     	   	
			     	   							
					<AboutReimo/>
					<Ausbauten/>
					<Advice />
			     	   	
		  			<Box sx={{paddingTop: "40px", paddingTop: "40px", display: {
																		xs: 'none',
																		sm: 'none',  
																		md: 'block',  
																		lg: 'block',  
																		xl: 'block',  																		
																		}}}> 
							<Box sx={{paddingTop: "0px"}}>
								<Box class="highlightContainer" sx={{	textAlign: "center", 
																		color: "#000"}}>					
									<Grid container style={{paddingTop: "40px"}}>
							        		<Grid item xs={12}>
									      		<Grid container spacing={2}>
									        		<Grid item xs={0} sm={0} md={1} lg={1} xl={2}>
										     	   </Grid>
										     	   <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
									        			{t("Filter")}:&nbsp;										     	   
										     	   </Grid>
									        		<Grid item xs={11} sm={11} md={9} lg={9} xl={7}>
									        			{props.props.filterModelNew.producer == "all" ? (
										        			<Chip color="success" onClick={(e) => handleFilterModel("all")} icon={<DoneIcon sx={{ "&&": { color: "white" } }} />}  sx={{marginRight: "10px"}}  label={t("AlleHersteller")} />				
														) :(
															<Chip color="primary" onClick={(e) => handleFilterModel("all")}  sx={{marginRight: "10px"}}  label={t("AlleHersteller")} />
														)}
									        			{filterCar("ford") === true ? (
															<>
											        			{props.props.filterModelNew.producer == "ford" ? (
												        			<Chip color="success" onClick={(e) => handleFilterModel("ford")}  icon={<DoneIcon sx={{ "&&": { color: "white" } }} />} sx={{marginRight: "10px"}} label="Ford" />				
																) :(
												        			<Chip color="primary" onClick={(e) => handleFilterModel("ford")} sx={{marginRight: "10px"}} label="Ford" />				
																)}
															</>
															) :(
															<></>
														)}
									        			{filterCar("vw") === true ? (
															<>
											        			{props.props.filterModelNew.producer == "vw" ? (
												        			<Chip color="success" onClick={(e) => handleFilterModel("vw")} icon={<DoneIcon sx={{ "&&": { color: "white" } }} />} sx={{marginRight: "10px"}} label="Volkswagen" />				
																) :(
												        			<Chip color="primary" onClick={(e) => handleFilterModel("vw")} sx={{marginRight: "10px"}} label="Volkswagen" />				
																)}
															</>
															) :(
															<></>
														)}

										     	   </Grid>
									        		<Grid item xs={0} sm={0} md={1} lg={1} xl={2}>
										     	   </Grid>
									     	   </Grid>
								     	   </Grid>
						     	   	</Grid>
									<Grid container style={{paddingTop: "5px", paddingBottom: "10px"}}>
							        		<Grid item xs={12}>
									      		<Grid container spacing={2}>
									        		<Grid item xs={0} sm={0} md={1} lg={1} xl={2}>
										     	   </Grid>
										     	   <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
										     	   </Grid>
									        		<Grid item xs={11} sm={11} md={9} lg={9} xl={7}>
									        			{props.props.filterModelNew.expansion == "all" ? (
										        			<Chip color="success" onClick={(e) => handleFilterExpansion("all")} icon={<DoneIcon sx={{ "&&": { color: "white" } }} />} sx={{marginRight: "10px"}}  label={t("AlleAusbauten")} />				
														) :(
															<Chip color="primary" onClick={(e) => handleFilterExpansion("all")}  sx={{marginRight: "10px"}}  label={t("AlleAusbauten")} />
														)}
									        			{filterModell("triostyle") === true ? (
															<>
											        			{props.props.filterModelNew.expansion == "triostyle" ? (
												        			<Chip color="success" onClick={(e) => handleFilterExpansion("triostyle")}  icon={<DoneIcon sx={{ "&&": { color: "white" } }} />} sx={{marginRight: "10px"}} label="TrioStyle" />				
																) :(
												        			<Chip color="primary" onClick={(e) => handleFilterExpansion("triostyle")} sx={{marginRight: "10px"}} label="TrioStyle" />				
																)}
															</>
															) :(
															<></>
														)}
									        			{filterModell("multistyle") === true ? (
															<>
											        			{props.props.filterModelNew.expansion == "multistyle" ? (
												        			<Chip color="success" onClick={(e) => handleFilterExpansion("multistyle")}  icon={<DoneIcon sx={{ "&&": { color: "white" } }} />} sx={{marginRight: "10px"}} label="MultiStyle" />				
																) :(
												        			<Chip color="primary" onClick={(e) => handleFilterExpansion("multistyle")} sx={{marginRight: "10px"}} label="MultiStyle" />				
																)}
															</>
															) :(
															<></>
														)}
									        			{filterModell("weekender2") === true ? (
															<>
											        			{props.props.filterModelNew.expansion == "weekender2" ? (
												        			<Chip color="success" onClick={(e) => handleFilterExpansion("weekender2")}  icon={<DoneIcon sx={{ "&&": { color: "white" } }} />} sx={{marginRight: "10px"}} label="Weekender 2" />				
																) :(
												        			<Chip color="primary" onClick={(e) => handleFilterExpansion("weekender2")} sx={{marginRight: "10px"}} label="Weekender 2" />				
																)}
															</>
															) :(
															<></>
														)}
														{filterModell("camp2") === true ? (
															<>
											        			{props.props.filterModelNew.expansion == "camp2" ? (
												        			<Chip color="success" onClick={(e) => handleFilterExpansion("camp2")}  icon={<DoneIcon sx={{ "&&": { color: "white" } }} />} sx={{marginRight: "10px"}} label="Camp 2" />				
																) :(
												        			<Chip color="primary" onClick={(e) => handleFilterExpansion("camp2")} sx={{marginRight: "10px"}} label="Camp 2" />				
																)}
															</>
															) :(
															<></>
														)}
										     	   </Grid>
									        		<Grid item xs={0} sm={0} md={1} lg={1} xl={2}>
										     	   </Grid>
									     	   </Grid>
								     	   </Grid>
						     	   	</Grid>
						     	   	

									
									
    <ReimoSwiper
        height="650px"
        slidesPerView={3}
        spaceBetween={30}
        loop={false}
        resetOnChildrenChange={true}

    >
    {visibleCars.map((model) => (
        <SwiperSlide key={`${model.producer}-${model.expansion}`}>
            <CarCard model={model}/>
        </SwiperSlide>
    ))}
        </ReimoSwiper>									
									
									
									
																
								</Box>			
								<Box style={{marginLeft: "10px", marginTop: "10px"}}>{t("AngabenHinsichtlichWerten")}</Box>
							</Box>	

							<span ref={ref3} />
	
	        				{inView3 === true && displayNewsletter == true ? (<Newsletter open={true} handleNewsletterDisplay={setDisplayNewsletter}/>) : (<></>)}
						</Box>			     	   	

		  				<Box sx={{paddingTop: "40px", paddingTop: "40px", display: {
																		xs: 'block',
																		sm: 'block',  
																		md: 'none',  
																		lg: 'none',  
																		xl: 'none',  																		
																		}}}> 
							<Box sx={{paddingTop: "0px"}}>
								<Box class="highlightContainer" sx={{	textAlign: "center", 
																		color: "#000"}}>	
									<center>				
									<h2 class="highlightText headlineNewPoint">{t("OurCars")}</h2>
									<h3 class="highlightText sloganNewPoint">{t("ExploreOurModels")}</h3>
									</center>				

									<Swiper
									        slidesPerView={1}
									        spaceBetween={30}
									        freeMode={true}
									        navigation={true}
									        pagination={{
									          clickable: true,
									        }}
									        modules={[FreeMode, Pagination]}
									        className="carsSwiper"
									        style={{minHeight: "650px", backgroundColor: "hsla(0,0%,94.9%,.5)"}}
									      >
											{models.cars.map((model) => (
												<>
													{model.onlinestatus == "online" ? (
											        	<SwiperSlide>
															<CarCard model={model}/>																						
											        	</SwiperSlide>
														):(<></>)
													}
									        	</>
									        ))}
									</Swiper>								
								</Box>			
							</Box>	
		  					<Box style={{marginLeft: "10px", marginTop: "10px"}}>{t("AngabenHinsichtlichWerten")}</Box>
		  				
							<span ref={ref3} />
	
	        				{inView3 === true && displayNewsletter == true ? (<Newsletter open={true} handleNewsletterDisplay={setDisplayNewsletter}/>) : (<></>)}
							

						</Box>

			     	   	
			     	   	
						<span ref={ref1} />
        				{inView1 === true && props.props.displayAdvice === true ? (<DisplayVideo display={true} handleDisplayVideo={handleDisplayVideo}/>) : (<></>)}

	 
						<hr className="spacer"/>

					<ReimoAtTheNews/>
						
	
					<br/><br/><br/>						  				
		  				
		  				<Box sx={{paddingTop: "40px"}}> 
							
						
		
		  				<Box sx={{paddingTop: "40px"}}> 
							<ContactPersons profil={props.props.profil}/>
						</Box>
	
	   				</Box>
   			</Box>
   		</>
   	)
}

export default function StartPage(props) {

  return <StartContent props={props}/>;
}